import gql from "graphql-tag";

export const ADD_ACTIVE_CHAT = gql`
  mutation ($input: activeChatInput) {
    addActiveChat(input: $input) {
      _id
    }
  }
`;
